<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Aguarde ...</p>
</ngx-spinner>
<!-- Navigation Menu -->

<nav class="navbar navbar-expand-lg fixed-top shadow-sm py-2" style="background-color: rgba(255, 255, 255, 0.95);">
  <div class="container-fluid px-5">
    <a href="#">
      <img src="assets/images/logo.png" alt="E-Cidadanias Logo" height="80">
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
      <ul class="navbar-nav align-items-center">
        <li class="nav-item mx-3">
          <a class="nav-link px-3 fw-medium" (click)="navigateToSection('servicos')" style="cursor: pointer; font-size: 1.05rem; transition: color 0.3s ease; color: #333;">Serviços</a>
        </li>
        <li class="nav-item mx-3">
          <a class="nav-link px-3 fw-medium" (click)="navigateToSection('como-funciona')" style="cursor: pointer; font-size: 1.05rem; transition: color 0.3s ease; color: #333;">Como Funciona</a>
        </li>
        <li class="nav-item mx-3">
          <a class="nav-link px-3 fw-medium" (click)="navigateToSection('depoimentos')" style="cursor: pointer; font-size: 1.05rem; transition: color 0.3s ease; color: #333;">Depoimentos</a>
        </li>
        <li class="nav-item mx-3">
          <a class="nav-link px-3 fw-medium" (click)="navigateToSection('contato')" style="cursor: pointer; font-size: 1.05rem; transition: color 0.3s ease; color: #333;">Contato</a>
        </li>
        <li class="nav-item ms-3">
          <button class="btn btn-outline-dark px-4 fw-medium" style="font-size: 1.05rem; border-width: 2px; transition: all 0.3s ease;" (click)="login()">Login</button>
        </li>
      </ul>
    </div>
  </div>
</nav>

<style>
.nav-link:hover {
  color: #666 !important;
}

.btn-outline-dark:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  background-color: #333;
  color: white;
}

.navbar {
  border-bottom: 1px solid rgba(0,0,0,0.05);
  backdrop-filter: blur(5px);
}

.stat-number {
  color: #153658;
  font-size: 2.5rem;
  font-weight: 700;
  display: block;
  margin-bottom: 0.5rem;
  text-shadow: 0 2px 4px rgba(21, 54, 88, 0.1);
  transition: all 0.3s ease;
  background: linear-gradient(135deg, #153658 0%, #1a4370 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.stat-label {
  color: #153658;
  font-size: 1rem;
  font-weight: 500;
  display: block;
  opacity: 0.8;
}

.stat-item {
  text-align: center;
  padding: 1.5rem;
  transition: all 0.3s ease;
  border-radius: 12px;
  background: rgba(21, 54, 88, 0.02);
  border: 1px solid rgba(21, 54, 88, 0.05);
}

.stat-item:hover {
  background: rgba(21, 54, 88, 0.04);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(21, 54, 88, 0.08);
}

.stat-item:hover .stat-number {
  transform: scale(1.05);
  background: linear-gradient(135deg, #1a4370 0%, #153658 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.researcher-stats {
  display: flex;
  justify-content: space-around;
  margin-top: 2rem;
  padding: 1.5rem;
  background: rgba(21, 54, 88, 0.02);
  border-radius: 16px;
  border: 1px solid rgba(21, 54, 88, 0.05);
  box-shadow: 0 4px 20px rgba(21, 54, 88, 0.03);
}

@media (max-width: 768px) {
  .researcher-stats {
    flex-direction: column;
    gap: 1rem;
  }
  
  .stat-item {
    padding: 1rem;
  }
  
  .stat-number {
    font-size: 2rem;
  }
}
</style>

<!-- Add margin-top to account for fixed navbar -->
<div class="coleta-pesquisador-container" style="margin-top: 76px;">
  <div class="container">
    <h1 class="text-center mb-5">Cadastro de Pesquisador</h1>
    <div class="row">
      <!-- Lado Esquerdo - Chamadas para Ação -->
      <div class="col-md-6">
        <div class="info-section">
          <!-- Chamada para Pesquisadores -->
          <div class="cta-card researcher-cta">
            <div class="researcher-header">
              <i class="fas fa-search researcher-icon" style="color: #153658;"></i>
              <h2>Junte-se à Nossa Equipe de Pesquisadores</h2>
              <p class="subtitle">Seja parte de uma equipe especializada em genealogia italiana</p>
            </div>

            <div class="benefits">
              <div class="benefit-grid">
                <div class="benefit-item">
                  <i class="fas fa-archive" style="color: #153658;"></i>
                  <h4>Acesso a Arquivos</h4>
                  <p>Acesso a arquivos históricos italianos</p>
                </div>
                <div class="benefit-item">
                  <i class="fas fa-tasks" style="color: #153658;"></i>
                  <h4>Gestão de Projetos</h4>
                  <p>Plataforma para gerenciar suas pesquisas</p>
                </div>
                <div class="benefit-item">
                  <i class="fas fa-money-bill-wave" style="color: #153658;"></i>
                  <h4>Remuneração</h4>
                  <p>Pagamentos justos e pontuais</p>
                </div>
                <div class="benefit-item">
                  <i class="fas fa-headset" style="color: #153658;"></i>
                  <h4>Suporte</h4>
                  <p>Equipe de suporte sempre disponível</p>
                </div>
              </div>
            </div>

            <div class="researcher-stats">
              <div class="stat-item">
                <span class="stat-number">200+</span>
                <span class="stat-label">Pesquisadores Ativos</span>
              </div>
              <div class="stat-item">
                <span class="stat-number">500+</span>
                <span class="stat-label">Pesquisas Mensais</span>
              </div>
              <div class="stat-item">
                <span class="stat-number">95%</span>
                <span class="stat-label">Satisfação</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Lado Direito - Formulário de Cadastro -->
      <div class="col-md-6">
        <div class="form-section">
          <div class="registration-message">
            <h2>Cadastro de Pesquisador</h2>
            <p class="lead">Preencha o formulário ao lado para se juntar à nossa equipe de pesquisadores genealógicos.</p>
          </div>

          <form [formGroup]="pesquisadorForm" (ngSubmit)="onSubmit()" class="form-container">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="nomeCompleto">Nome completo:</label>
                  <input 
                    type="text" 
                    id="nomeCompleto" 
                    formControlName="nomeCompleto" 
                    class="form-control"
                    placeholder="Digite o nome completo">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="cpf">CPF:</label>
                  <input 
                    type="text" 
                    id="cpf" 
                    formControlName="cpf" 
                    class="form-control"
                    placeholder="000.000.000-00"
                    [textMask]="{mask: cpfMask}">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="email">E-mail:</label>
                  <input 
                    type="email" 
                    id="email" 
                    formControlName="email" 
                    class="form-control"
                    placeholder="seu@email.com">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="telefone">Telefone:</label>
                  <input 
                    type="text" 
                    id="telefone" 
                    formControlName="telefone" 
                    class="form-control"
                    placeholder="(00) 00000-0000"
                    [textMask]="{mask: telefoneMask}">
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="endereco">Endereço completo:</label>
              <textarea 
                id="endereco" 
                formControlName="endereco" 
                class="form-control"
                placeholder="Digite o endereço completo"
                rows="3"></textarea>
            </div>

            <div class="form-group checkbox-group">
              <label class="mb-2">Áreas de Pesquisa:</label>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-check">
                    <input type="checkbox" id="brasil" formControlName="PESQUISADOR_BRASIL" class="form-check-input">
                    <label for="brasil" class="form-check-label">Brasil</label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-check">
                    <input type="checkbox" id="italia" formControlName="PESQUISADOR_ITALIA" class="form-check-input">
                    <label for="italia" class="form-check-label">Itália</label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-check">
                    <input type="checkbox" id="outros" formControlName="PESQUISADOR_OUTROS" class="form-check-input">
                    <label for="outros" class="form-check-label">Outros</label>
                  </div>
                </div>
              </div>
              <div class="text-danger mt-1" *ngIf="hasResearchAreaError">
                Selecione pelo menos uma área de pesquisa
              </div>
            </div>

            <div class="form-group" *ngIf="pesquisadorForm.get('PESQUISADOR_OUTROS')?.value">
              <label for="outrasPesquisas">Informar outras áreas:</label>
              <textarea 
                id="outrasPesquisas" 
                [(ngModel)]="outrasPesquisas" 
                [ngModelOptions]="{standalone: true}"
                class="form-control"
                placeholder="Digite as outras áreas de pesquisa"
                rows="2"></textarea>
            </div>

            <div class="form-actions">
              <button type="submit" class="btn btn-primary w-100" [disabled]="!pesquisadorForm.valid">
                <i class="fas fa-save me-2"></i>
                Enviar Cadastro
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Sucesso -->
<ng-template #successModal>
  <div class="modal-header">
    <h4 class="modal-title">Cadastro Realizado com Sucesso!</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modalService.dismissAll()">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="modal-body text-center">
    <i class="fas fa-check-circle text-success" style="font-size: 4rem;"></i>
    <p class="mt-3">Seu cadastro foi realizado com sucesso! Em breve entraremos em contato para mais informações.</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modalService.dismissAll()">OK</button>
  </div>
</ng-template>

<!-- Modal de Erro -->
<ng-template #errorModal>
  <div class="modal-header">
    <h4 class="modal-title">Erro no Cadastro</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modalService.dismissAll()">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="modal-body text-center">
    <i class="fas fa-exclamation-circle text-danger" style="font-size: 4rem;"></i>
    <p class="mt-3">Ocorreu um erro ao realizar seu cadastro. Por favor, tente novamente mais tarde.</p>
    <p class="mt-3">{{errorMessage}}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Fechar</button>
  </div>
</ng-template> 